export const config = {
   serverRoute: "https://test-prueba-production.up.railway.app"
   //serverRoute: "http://localhost:3001"
}

export const SocketRoute = {
   serverRoute: "https://railway.grupo-hoteles.com"
   //serverRoute: "http://localhost:3001"
}

export const CLoubedsRoute ={
   serverRoute: "https://railway.grupo-hoteles.com"
   //serverRoute:"http://localhost:3001"
}

export const Environment ={
  propertyID:"315187",
  Token:"cbat_kx0f4MXpoAh6mD5ekbYoV3mRwAKnRUZB"
}